type Achievement = { progress: { criteria: { threshold: number } } };

type AchievementCategory = {
  category_group: string;
  completed?: Achievement[];
  in_progress?: Achievement[];
};

type UserAchievementsResponse = { achievements_info?: AchievementCategory[] };

const CATEGORIES_ORDERED_BY_THRESHOLD = new Set([
  "weekly_streaks",
  "activities",
]);

const byThreshold = (a: Achievement, b: Achievement) =>
  a.progress.criteria.threshold - b.progress.criteria.threshold;

const sortCategory = <C extends AchievementCategory>(category: C): C => {
  if (!CATEGORIES_ORDERED_BY_THRESHOLD.has(category.category_group)) {
    return category;
  }

  return {
    ...category,
    ...(category.completed && {
      completed: [...category.completed].sort(byThreshold),
    }),
    ...(category.in_progress && {
      in_progress: [...category.in_progress].sort(byThreshold),
    }),
  };
};

// The backend returns streaks and activities in whatever order Antavo does, but
// they read as a progression ("3 weeks", "6 weeks", ...) and belong lowest to
// highest. Sorting is stable, so equal thresholds keep their incoming order.
export const sortUserAchievementsByThreshold = <
  T extends UserAchievementsResponse
>(
  response: T
): T => {
  if (!response.achievements_info) {
    return response;
  }

  return {
    ...response,
    achievements_info: response.achievements_info.map(sortCategory),
  };
};
